import { getTheme, mergeStyles } from '@fluentui/react';
import React from 'react';
import { TooltipText } from '../../TooltipText';
import { empty } from '../JsonFrame';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';

interface SectionHeaderPorps {
  val: string;
  isZoomInActive?: boolean;
}

export const SectionHeaderType: React.FunctionComponent<SectionHeaderPorps> = (props): JSX.Element => {
  const { palette, fonts } = getTheme();
  const sectionHeaderClass = mergeStyles(
    {
      color: palette.black,
      fontFamily: fonts.mediumPlus.fontFamily,
      fontSize: fonts.mediumPlus.fontSize,
      lineHeight: fonts.mediumPlus.lineHeight,
      height: 20
    },
    'wordBreak ' + (props.isZoomInActive ? 'pl-3' : '')
  );

  return !empty(props.val) ? (
    <h4 className={sectionHeaderClass}>{props.val}</h4>
  ) : (
    <JsonContentValidationMessage
      message={TooltipText.sectionHeaderTypeValidationMessage}
      validationMessageWrapperClass={props.isZoomInActive ? 'mb-2 pl-3' : ''}
    />
  );
};
